export enum ComponentType {
    SUPER_ADMIN_ORGANIZATION = "superadmin_organization",
    SUPER_ADMIN_USER = "superadmin_user",
    CHIEF_ACCOUNTANT_USER = "chief-account",
    CLIENT_APPOINTMENTS = "client-appoinment",
    ACCOUNTANT_APPOINTMENTS = "accountant-dashboard",
    CHIEF_ACCOUNTANT_APPOINTMENTS = "chief-Appoinment",
    CHIEF_ACCOUNTANT_FEEDBACK = "ca-feedback",
    EMPLOYEE_RETURNS = "ca-employee-returns",
    ACC_EMPLOYEE_RETURNS = "acc-employee-returns",
    ACC_MY_ACCOUNTING_FIRM = 'acc-my-accounting-firm',
    CA_EMPLOYEE_SATISFACTION = 'ca-employee-satisfaction',
    CA_CUST_IDENTIFICATION_NEED = 'ca-indentify-customer-needs',
    ACC_CUST_IDENTIFICATION_NEED = 'acc-indentify-customer-needs',
    CA_PERIODIC_EVALUTION = 'ca-periodic-evaluation',
    ACC_MY_PROFESSIONAL_JOURNEY = 'acc-my-professional-journey',
    CA_ANNUAL_EVALUATION = 'ca-annual-evaluation',
    ACC_ANNUAL_INTERVIEW = 'acc-annual-interview',
    CA_ACCOUNTANT_PERFORMANCE_FEEDBACK = 'ca-accountant-performance-feedback'
}
